<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_viii"></a><a id="page_ix"></a>Sex<br/>and<br/>Shopping</p>
<p class="halftitle1">The Confessions of a<br/>Nice Jewish Girl</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle002.vue?3c697ffb